class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.productJSON = {}; // populated on load from DOM, via @getProductJSON
    this.variantsByTitleJSON; // populated from productJSON. Allows us to get variant objects directly by their title
    this.current_variant = {}; // populated on init, via. @getActiveVariant. If false, means that there's no active variant.
    this.VariantSelection = this.querySelector("variant-selection");
    this.cart = document.querySelector("cart-drawer");

    this.changeEvent = new CustomEvent("variant:changed", { bubbles: true });
  }

  getProductJSON() {
    if (this.querySelector("[data-product-json]")) {
      this.productJSON = JSON.parse(
        this.querySelector("[data-product-json]").innerText
      );
    }
  }

  mapVariantsByTitle() {
    /* input:

      product json array:
      variants = [
        { "id": ..., "price"... "title": "Variant title"}
      ]

      ==> what we want:

      variants = {
        "Variant Title": variant obj,
        "Variant Title 2": variant obj,
      }

      */

    /* prevent building it */
    if (!this.variantsByTitleJSON) {
      this.variantsByTitleJSON = {};
      if (this.productJSON && this.productJSON.variants) {
        this.productJSON.variants.filter((variant) => {
          this.variantsByTitleJSON[variant.title] = variant;
        });
      }
    }

    this.VariantSelection.variantsByTitleJSON = this.variantsByTitleJSON;
  }

  listenForVariantChange() {
    this.addEventListener("variant-selection:changed", this.onVariantChange);
  }

  onVariantChange(event) {
    if (this.VariantSelection.activeVariantTitle) {
      this.setCurrentVariant(true);
    }
  }

  setCurrentVariant(notOnLoad) {
    this.current_variant =
      this.variantsByTitleJSON[this.VariantSelection.activeVariantTitle];
    this.dispatchEvent(this.changeEvent);

    if (notOnLoad) {
      this.refreshDOM();
    }
  }

  replaceGalleryImages(sectionContent) {
    const stopVideo = (v) => (window.ecVideos ? window.ecVideos.stop(v) : v.pause());
    // Nodes from the fetched section are re-created in this document, not moved: Safari loads a <video> adopted from a
    // parsed document despite preload="none".
    const imported = (root) => [...root.children].map((node) => document.importNode(node, true));
    // Which videos the gallery shows, in order: the variant's own (v) and the general ones (g, those not already the variant's).
    const videoSig = (root) => (root ? [...root.querySelectorAll(":scope > [data-video-id]")].map((el) => (el.dataset.variantVideo ? "v" : "g") + el.dataset.videoId).join(",") : "");

    // A variant with its own videos can bring a second slide to a gallery that had one: the strip arrives with it; a
    // variant that leaves one slide takes it away.
    let addedThumbs = false;
    let removedThumbs = false;
    const freshThumbList = this.freshDOM.querySelector(".productpage__media-thumbList");
    const thumbList = document.querySelector(".productpage__media-thumbList");
    const mediaMain = document.querySelector(".productpage__media-main");
    if (!thumbList && freshThumbList && mediaMain) {
      mediaMain.after(document.importNode(freshThumbList, true));
      addedThumbs = true;
    } else if (thumbList && !freshThumbList) {
      thumbList.remove();
      removedThumbs = true;
    }
    // The galleries keep a list of each other (swipeable-area.js, found once): found again, with or without the strip.
    if (addedThumbs || removedThumbs) {
      document.querySelectorAll('swipeable-area[group="product-gallery"]').forEach((area) => (area.siblings = null));
    }

    let keepSlide = false;
    const mainSlider = document.querySelector("#Product-gallery-main .swipeable-slider");
    const freshMain = this.freshDOM.querySelector("#Product-gallery-main .swipeable-slider");
    if (mainSlider && freshMain && (addedThumbs || removedThumbs || videoSig(mainSlider) !== videoSig(freshMain))) {
      // Other videos (the variant's own came or went, and with them which general ones show once): the slides and
      // thumbnails are rebuilt from the fresh render, in its order and numbering. What played is stopped first.
      mainSlider.querySelectorAll("video").forEach(stopVideo);
      mainSlider.replaceChildren(...imported(freshMain));
      const thumbSlider = document.querySelector("#Product-gallery-thumb .swipeable-slider");
      const freshThumbs = this.freshDOM.querySelector("#Product-gallery-thumb .swipeable-slider");
      if (thumbSlider && freshThumbs && !addedThumbs) thumbSlider.replaceChildren(...imported(freshThumbs));
      // importNode builds the thumbnails before they are in the page, so they found no gallery then: now they do.
      document.querySelectorAll(".productpage__media-gallery swipeable-thumbnail").forEach((thumb) => {
        thumb.swiper = thumb.closest("swipeable-area");
        thumb.index = parseInt(thumb.getAttribute("specific-index"), 10) || 0;
      });
      // init, not only build: a gallery that started with one slide had no swiping and no arrows yet.
      ["#Product-gallery-main", "#Product-gallery-thumb"].forEach((id) => {
        const area = document.querySelector(id);
        if (area && typeof area.init === "function") area.init();
      });
    } else {
      // The same videos: only the variant's picture changes (slide 1 and thumbnail 1), and a video that plays goes on:
      // the gallery stays on its slide (moving away would stop it, product-videos.js).
      keepSlide = !!document.querySelector("#Product-gallery-main .swipeable-item-active .is-playing");
      const mainImageQuery = "#Product-gallery-main .productpage-media__image img";
      const mainThumbImageQuery = "#Product-gallery-thumb .swipeable-item img";
      const mainImage = this.freshDOM.querySelector(mainImageQuery);
      const mainThumbImage = this.freshDOM.querySelector(mainThumbImageQuery);
      // Either can be missing on the page (one slide: no thumbnail strip), so each is replaced only where it is.
      const currentImage = document.querySelector(mainImageQuery);
      const currentThumbImage = document.querySelector(mainThumbImageQuery);
      if (mainImage && currentImage) currentImage.replaceWith(document.importNode(mainImage, true));
      if (mainThumbImage && currentThumbImage) currentThumbImage.replaceWith(document.importNode(mainThumbImage, true));
    }

    // The corner video tile (snippets/productpage-video-tile) shows the first video in the new order.
    const tile = document.querySelector(".productpage__media-main [data-video-jump]");
    const freshTile = this.freshDOM.querySelector(".productpage__media-main [data-video-jump]");
    if ((tile && tile.dataset.videoJump) !== (freshTile && freshTile.dataset.videoJump)) {
      if (tile) tile.remove();
      const area = document.getElementById("Product-gallery-main");
      if (freshTile && area) area.after(document.importNode(freshTile, true));
    }

    // The full view (snippets/productpage-media-full) shows the variant's own videos too: renewed when they differ.
    const fullBody = document.querySelector(".productpage-media__full-body");
    const freshFullBody = this.freshDOM.querySelector(".productpage-media__full-body");
    if (fullBody && freshFullBody && fullBody.dataset.videoSig !== freshFullBody.dataset.videoSig) {
      fullBody.querySelectorAll("video").forEach(stopVideo);
      fullBody.replaceChildren(...imported(freshFullBody));
      fullBody.dataset.videoSig = freshFullBody.dataset.videoSig;
    }

    // To slide 1, the new variant's picture, however the visitor got where they are: a swipe leaves hasSwiped set, which
    // thumbnailCallback took as a reason to stay, so a playing video went on after a swipe but stopped after an arrow.
    if (keepSlide) return;
    const swipers = document.querySelectorAll(
      "#Product-gallery-main, #Product-gallery-thumb"
    );
    swipers.forEach((swiper) => {
      swiper.hasSwiped = false;
      swiper.thumbnailCallback(0);
    });
  }

  _nodeUpdatePrices() {
    document
      .querySelectorAll(".productpage__pricing")
      .forEach(
        (pricing, index) =>
          (pricing.innerHTML = this.freshDOM.querySelectorAll(
            ".productpage__pricing"
          )[index].innerHTML)
      );
    document.querySelector(".productpage__submit").innerHTML =
      this.freshDOM.querySelector(".productpage__submit").innerHTML;

    const stockLine = document.querySelector(".productpage__stock-line");
    const freshStockLine = this.freshDOM.querySelector(".productpage__stock-line");
    if (stockLine && freshStockLine) stockLine.innerHTML = freshStockLine.innerHTML;
  }

  _nodeUpdateProductOptions() {
    this.variantOptionGroupItems = this.freshDOM.querySelectorAll(
      "variant-selection variant-option-group"
    );

    // The options are rendered anew: a keyboard user keeps focus on the chosen option of the group they were in.
    const groups = Array.from(this.querySelectorAll("variant-selection variant-option-group"));
    const focused = document.activeElement && document.activeElement.closest && document.activeElement.closest("variant-option-group");
    const focusIndex = groups.indexOf(focused);

    groups.forEach((elem, index) => {
      elem.innerHTML = this.variantOptionGroupItems[index].innerHTML;
    });

    if (focusIndex >= 0) {
      // The gift card's amounts are a dropdown (component-variant-selection): focus goes back to it, not the hidden buttons.
      const target = groups[focusIndex].querySelector("[data-variant-dropdown]") || groups[focusIndex].querySelector("variant-option.radio-active") || groups[focusIndex].querySelector("variant-option");
      if (target) target.focus({ preventScroll: true });
    }
  }

  _nodeUpdateOnSaleAttribute() {
    let newAttributeValue = this.freshDOM.querySelector(
      ".productpage[data-on-sale]"
    ).dataset.onSale;

    document
      .querySelector(".productpage[data-on-sale]")
      .setAttribute("data-on-sale", newAttributeValue);
  }

  _nodeUpdateUnitPrices() {
    if (document.querySelector(".productpage .unit-pricing")) {
      document
        .querySelectorAll(".productpage .unit-pricing")
        .forEach((elem) => {
          elem.innerHTML =
            this.freshDOM.querySelector(".unit-pricing").innerHTML;
        });
    }
  }

  // "Videoer" (snippets/productpage-videos) lists the selected variant's own videos first: the new variant's list, or
  // the fold-out comes or goes. Open, it stays open with the new cards; the same videos leave it untouched.
  _nodeUpdateVideos() {
    const box = document.querySelector("[data-pdp-videos]");
    const fresh = this.freshDOM.querySelector("[data-pdp-videos]");
    if (!box || !fresh || box.dataset.videoSig === fresh.dataset.videoSig) return;
    box.querySelectorAll("video").forEach((v) => (window.ecVideos ? window.ecVideos.stop(v) : v.pause()));
    box.dataset.videoSig = fresh.dataset.videoSig;
    const dropdown = box.querySelector(".pdp-videos");
    const freshDropdown = fresh.querySelector(".pdp-videos");
    if (dropdown && freshDropdown) {
      [".pdp-videos__peek", ".pdp-videos__row"].forEach((selector) => {
        const current = dropdown.querySelector(selector);
        const next = freshDropdown.querySelector(selector);
        if (current && next) current.innerHTML = next.innerHTML;
      });
      // The row's rail (swipeable-area.js) starts at the first card again and redraws its bar for the new cards.
      const rail = dropdown.querySelector("swipeable-area[rail]");
      if (rail && rail.rail) {
        rail.scrollLeft = 0;
        rail.rail.measure();
      }
      if (dropdown.isActive && typeof dropdown.expandContainer === "function") dropdown.expandContainer();
    } else {
      // A rail that goes with the old fold-out lets go of its window listeners and observer (swipeable-area.js).
      box.querySelectorAll("swipeable-area[rail]").forEach((area) => area.rail && area.rail.destroy());
      box.innerHTML = fresh.innerHTML;
    }
  }

  updateStickyATC() {
    document.querySelector(".pdp__sticky-atc__content").innerHTML =
      this.freshDOM.querySelector(".pdp__sticky-atc__content").innerHTML;
    fitStickyATC();
  }

  // Same selectors cart.js#pdpCartAware swaps: both lines price off the selected variant.
  _nodeUpdateIncentives() {
    // The set's contents follow the variant too (a gift product's variants are different sets).
    [".pdp-freegift-countdown", ".pdp-delivery-progress", ".productpage__package"].forEach((selector) => {
      const current = document.querySelector(selector);
      const fresh = this.freshDOM.querySelector(selector);
      if (current && fresh) current.innerHTML = fresh.innerHTML;
    });
  }

  // Only the newest variant's response is applied: arrow keys can switch faster than the section arrives, and an older
  // response landing last would show (and focus) a variant other than the one going in the cart.
  refreshDOM() {
    this.VariantSelection.updateId(this.current_variant.id);
    this.section_id = this.closest(".shopify-section")
      .getAttribute("id")
      .replace("shopify-section-", "");
    const seq = (this.refreshSeq = (this.refreshSeq || 0) + 1);
    // A refused add's message belonged to the variant that was in view.
    const formError = this.querySelector("[data-form-error]");
    if (formError) formError.hidden = true;

    // The page's own query is kept (a draft's preview link carries its preview_key there).
    const sectionUrl = new URL(location.href);
    sectionUrl.hash = "";
    sectionUrl.searchParams.set("variant", this.current_variant.id);
    sectionUrl.searchParams.set("section_id", this.section_id);
    fetch(sectionUrl.pathname + sectionUrl.search)
      .then((res) => {
        return res.text();
      })
      .then((resText) => {
        if (seq !== this.refreshSeq) return;
        var domParser = new DOMParser();
        this.freshDOM = domParser.parseFromString(resText, "text/html");

        this._nodeUpdatePrices();
        this._nodeUpdateProductOptions();
        this._nodeUpdateOnSaleAttribute();
        this._nodeUpdateUnitPrices();
        this.replaceGalleryImages();
        this.updateStickyATC();
        this._nodeUpdateIncentives();
        this._nodeUpdateVideos();
      });
  }

  onFormSubmit() {
    this.dispatchEvent(new CustomEvent("form:atc"));
  }

  registerFormSubmit() {
    this.form = this.querySelector("form");
    this.addEventListener("submit", (e) => {
      e.preventDefault();
      if (customElements.get("cart-drawer")) return this.onFormSubmit();
      // cart.js (the cart drawer, which does the add) runs a moment after this script: a submit in that gap waits for
      // it, so a chosen add-on (component-fixed-addon.js, also before cart.js) still goes in the same request; one
      // wait, the buttons off meanwhile (more clicks would add more). No cart.js within 4 s: the form posts natively,
      // as before this script, and returns with #cart-open (snippets/atc-return-to.liquid).
      if (this.waitingForCart) return;
      this.waitingForCart = true;
      const buttons = [...this.form.elements].filter((el) => el.type === "submit" && !el.disabled);
      buttons.forEach((b) => (b.disabled = true));
      const go = (native) => {
        if (!this.waitingForCart) return;
        this.waitingForCart = false;
        // The buttons' name="submit" shadows form.submit.
        if (native) return HTMLFormElement.prototype.submit.call(this.nativeForm());
        buttons.forEach((b) => (b.disabled = false));
        this.onFormSubmit();
      };
      customElements.whenDefined("cart-drawer").then(() => go(false));
      setTimeout(() => go(true), 4000);
    });
  }

  // A chosen fixed add-on lives in component-fixed-addon.js, not in an input: for the native post, a copy of the form
  // in /cart/add's items[] format carries both lines (as cart.js addItemFromForm does). No add-on: the form itself.
  nativeForm() {
    const addon = this.form.querySelector("fixed-addon");
    const addonId = addon && addon.selectedVariant && addon.selectedVariant();
    if (!addonId) return this.form;
    const post = document.createElement("form");
    post.method = "post";
    post.action = this.form.action;
    post.hidden = true;
    const add = (name, value) => post.append(Object.assign(document.createElement("input"), { type: "hidden", name, value }));
    const data = new FormData(this.form);
    add("items[][id]", data.get("id"));
    add("items[][quantity]", data.get("quantity") || 1);
    if (data.get("selling_plan")) add("items[][selling_plan]", data.get("selling_plan"));
    data.forEach((value, key) => {
      if (/^properties\[.+\]$/.test(key)) add("items[][" + key.replace("[", "]["), value);
    });
    add("items[][id]", addonId);
    add("items[][quantity]", 1);
    add("items[][properties][_atc_source]", "addon");
    data.forEach((value, key) => {
      if (!/^(id|quantity|selling_plan|properties\[.+\])$/.test(key) && typeof value === "string") add(key, value);
    });
    document.body.append(post);
    return post;
  }

  connectedCallback() {
    this.getProductJSON();
    this.mapVariantsByTitle();
    this.listenForVariantChange();
    this.setCurrentVariant();
    this.registerFormSubmit();
  }
}

// The selected variant's own values: the INCI where the variants' lists differ (snippets/product-inci.liquid) and the
// variant rows of the specifications (snippets/product-specs.liquid), in the Detaljer tab and the specs drawer.
document.addEventListener("variant:changed", (event) => {
  const variant = event.target.current_variant;
  if (!variant || !variant.id) return;
  document.querySelectorAll("[data-inci-variant]").forEach((list) => (list.hidden = list.dataset.inciVariant !== String(variant.id)));
  document.querySelectorAll("[data-spec-variant]").forEach((value) => (value.hidden = value.dataset.specVariant !== String(variant.id)));
});

customElements.define("product-form", ProductForm);

class ProductPageGrid extends HTMLElement {
  constructor() {
    super();
  }

  get headingAreaHeight() {
    return this.headingArea
      ? this.headingArea.getBoundingClientRect().height
      : 0;
  }

  get productFormHeight() {
    return this.productForm
      ? this.productForm.getBoundingClientRect().height
      : 0;
  }

  changeStickyTop(ele) {
    ele.style.setProperty("--sticky-top", this.headingAreaHeight + "px");
  }

  changeMargin(ele, val, direction) {
    let margin = "margin" + direction;
    ele.style[margin] = "-" + val + "px";
  }

  collectNodes() {
    this.productForm = this.querySelector(".productpage__form");
    this.headingArea = this.querySelector(".productpage-heading-area");
  }

  updateNodes() {
    if (window.innerWidth < 768) return;

    this.changeStickyTop(this.querySelector(".productpage__form"));
    this.productForm.style.marginTop = "-" + this.productFormHeight + "px";
    this.headingArea.style.marginBottom = this.productFormHeight + "px";

    var gall = this.querySelector(".productpage__media-gallery");
    var mainDropdowns = this.querySelector(".productpage-main-dropdowns");

    if (gall && mainDropdowns) {
      var differenceHeight =
        this.productForm.offsetHeight +
        this.headingArea.offsetHeight -
        gall.offsetHeight;

      if (differenceHeight > 0) {
        mainDropdowns.style.marginTop = "-" + differenceHeight + "px";
      }
    }

    [this.headingArea, this.productForm].forEach((node) => {
      node.classList.add("productpage-grid__item--sticky");
    });
  }

  reloadCalcs() {
    this.collectNodes();
    this.updateNodes();
  }

  connectedCallback() {
    this.collectNodes();
    this.updateNodes();
  }
}

customElements.define("productpage-grid", ProductPageGrid);

class WDNDisclosure extends HTMLElement {
  constructor() {
    super();
  }

  get getTrigger() {
    return (
      document.querySelector(this.getAttribute("trigger")) ||
      this.querySelector("[data-disclosure-trigger]")
    );
  }

  bindEvents() {
    if (this.getTrigger) {
      this.getTrigger.addEventListener("click", () => {
        this.focus();
      });
    }
  }

  connectedCallback() {
    this.content = this.querySelector("[data-disclosure-content]");
    this.bindEvents();
  }
}

customElements.define("wdn-disclosure", WDNDisclosure);

(function () {
  var pricematchContent = document.querySelector("[data-pricematch-content]");

  var pricematchOpen = function () {
    if (document.getSelection().toString().length > 0) {
      if (
        document
          .getSelection()
          .anchorNode.parentElement.classList.contains("productpage-heading")
      ) {
        pricematchContent.classList.add("active");
        document.addEventListener("click", pricematchClose);
        document.removeEventListener("selectionchange", pricematchOpen);
      }
    }
  };

  var pricematchClose = function () {
    /* keep open as long as we have selection. */
    if (document.getSelection().toString() == "") {
      pricematchContent.classList.remove("active");
      document.removeEventListener("click", pricematchClose);
      document.addEventListener("selectionchange", pricematchOpen);
    }
  };

  document
    .querySelector("[data-pricematch-close]")
    .addEventListener("click", (elem) => {
      pricematchContent.classList.remove("active");
      document.removeEventListener("click", pricematchClose);
      document.addEventListener("selectionchange", pricematchOpen);
    });

  document.addEventListener("selectionchange", pricematchOpen);
})();

// ModalUSPContent (the USP popups' lazy bodies) lives in modal.js, so the popups work on every page.

/* Sold-out alternatives drawer body: fetchContent() on first open, from the product recommendations route. Placeholders stay until real cards arrive, or give way to data-empty-text on failure. */
class AlternativesContent extends HTMLElement {
  constructor() {
    super();

    this.loaded = false;
  }

  fetchContent() {
    if (this.loaded) {
      return;
    }

    this.loaded = true;

    fetch(this.getAttribute("data-url"))
      .then((res) => {
        if (!res.ok) throw new Error(res.status);
        return res.text();
      })
      .then((txt) => {
        const section = new DOMParser()
          .parseFromString(txt, "text/html")
          .querySelector(".pdp-alternatives-grid");

        if (!section) throw new Error("no grid");
        this.innerHTML = section.outerHTML;
      })
      .catch(() => {
        this.loaded = false;
        this.showEmpty();
      });
  }

  showEmpty() {
    const text = this.getAttribute("data-empty-text");
    if (!text) return;

    const grid = document.createElement("div");
    grid.className = "pdp-alternatives-grid";
    const empty = document.createElement("p");
    empty.className = "pdp-alternatives-empty";
    empty.textContent = text;
    grid.appendChild(empty);
    this.replaceChildren(grid);
  }
}

customElements.define("alternatives-content", AlternativesContent);

// Measured, not breakpointed: label text and price lengths differ per market.
function fitStickyATC() {
  var row = document.querySelector(".pdp__sticky-atc [data-fit-row]");
  if (!row) return;
  var drops = [row.querySelector(".btn-label-compare"), row.querySelector(".btn-label-secondary")].filter(Boolean);
  drops.forEach((el) => el.classList.remove("is-dropped"));
  for (var i = 0; i < drops.length && row.scrollWidth > row.clientWidth + 1; i++) {
    drops[i].classList.add("is-dropped");
  }
}

(function () {
  var content = document.querySelector(".pdp__sticky-atc__content");
  if (!content) return;
  fitStickyATC();
  if (document.fonts) document.fonts.ready.then(fitStickyATC);
  if (window.ResizeObserver) new ResizeObserver(fitStickyATC).observe(content);
})();
